import type { Category } from '@/mocks/tvSeries';

interface CategoryTabsProps {
  categories: Category[];
  activeSlug: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ categories, activeSlug, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {categories.map((cat) => {
        const isActive = cat.slug === activeSlug;

        return (
          <button
            key={cat.slug}
            onClick={() => {
              onCategoryChange(cat.slug);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
            }`}
          >
            <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
            {cat.name}
          </button>
        );
      })}
    </div>
  );
}